import type { Icon as PhosphorIcon, IconWeight } from '@phosphor-icons/react';
import { cn } from '../lib/cn';

export type IconSize = 'sm' | 'md' | 'lg' | 'xl';

const sizes: Record<IconSize, string> = {
  sm: 'size-icon-sm',
  md: 'size-icon-md',
  lg: 'size-icon-lg',
  xl: 'size-icon-xl',
};

export interface IconProps {
  icon: PhosphorIcon;
  size?: IconSize;
  weight?: IconWeight;
  /** Accessible name. Without it the icon is decorative and hidden from assistive tech. */
  label?: string;
  className?: string;
}

/** Phosphor icon sized by tokens. Icons are bundled – no icon font or CDN request. */
export function Icon({
  icon: Glyph,
  size = 'md',
  weight = 'duotone',
  label,
  className,
}: IconProps) {
  return (
    <Glyph
      weight={weight}
      className={cn('shrink-0', sizes[size], className)}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    />
  );
}
